/* Modernizr 2.6.1 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-backgroundsize-borderimage-borderradius-boxshadow-flexbox-hsla-multiplebgs-opacity-rgba-textshadow-cssanimations-csscolumns-generatedcontent-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-applicationcache-canvas-canvastext-draganddrop-hashchange-history-audio-video-indexeddb-input-inputtypes-localstorage-postmessage-sessionstorage-websockets-websqldatabase-webworkers-geolocation-inlinesvg-smil-svg-svgclippaths-touch-webgl-shiv-mq-cssclasses-addtest-prefixed-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function D(a){j.cssText=a}function E(a,b){return D(n.join(a+";")+(b||""))}function F(a,b){return typeof a===b}function G(a,b){return!!~(""+a).indexOf(b)}function H(a,b){for(var d in a){var e=a[d];if(!G(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function I(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:F(f,"function")?f.bind(d||b):f}return!1}function J(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+p.join(d+" ")+d).split(" ");return F(b,"string")||F(b,"undefined")?H(e,b):(e=(a+" "+q.join(d+" ")+d).split(" "),I(e,b,c))}function K(){e.input=function(c){for(var d=0,e=c.length;d<e;d++)u[c[d]]=c[d]in k;return u.list&&(u.list=!!b.createElement("datalist")&&!!a.HTMLDataListElement),u}("autocomplete autofocus list placeholder max min multiple pattern required step".split(" ")),e.inputtypes=function(a){for(var d=0,e,f,h,i=a.length;d<i;d++)k.setAttribute("type",f=a[d]),e=k.type!=="text",e&&(k.value=l,k.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(f)&&k.style.WebkitAppearance!==c?(g.appendChild(k),h=b.defaultView,e=h.getComputedStyle&&h.getComputedStyle(k,null).WebkitAppearance!=="textfield"&&k.offsetHeight!==0,g.removeChild(k)):/^(search|tel)$/.test(f)||(/^(url|email)$/.test(f)?e=k.checkValidity&&k.checkValidity()===!1:e=k.value!=l)),t[a[d]]=!!e;return t}("search tel url email datetime date month week time datetime-local number range color".split(" "))}var d="2.6.1",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k=b.createElement("input"),l=":)",m={}.toString,n=" -webkit- -moz- -o- -ms- ".split(" "),o="Webkit Moz O ms",p=o.split(" "),q=o.toLowerCase().split(" "),r={svg:"http://www.w3.org/2000/svg"},s={},t={},u={},v=[],w=v.slice,x,y=function(a,c,d,e){var f,i,j,k=b.createElement("div"),l=b.body,m=l?l:b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),k.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),k.id=h,(l?k:m).innerHTML+=f,m.appendChild(k),l||(m.style.background="",g.appendChild(m)),i=c(k,a),l?k.parentNode.removeChild(k):m.parentNode.removeChild(m),!!i},z=function(b){var c=a.matchMedia||a.msMatchMedia;if(c)return c(b).matches;var d;return y("@media "+b+" { #"+h+" { position: absolute; } }",function(b){d=(a.getComputedStyle?getComputedStyle(b,null):b.currentStyle)["position"]=="absolute"}),d},A=function(){function d(d,e){e=e||b.createElement(a[d]||"div"),d="on"+d;var f=d in e;return f||(e.setAttribute||(e=b.createElement("div")),e.setAttribute&&e.removeAttribute&&(e.setAttribute(d,""),f=F(e[d],"function"),F(e[d],"undefined")||(e[d]=c),e.removeAttribute(d))),e=null,f}var a={select:"input",change:"input",submit:"form",reset:"form",error:"img",load:"img",abort:"img"};return d}(),B={}.hasOwnProperty,C;!F(B,"undefined")&&!F(B.call,"undefined")?C=function(a,b){return B.call(a,b)}:C=function(a,b){return b in a&&F(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=w.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(w.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(w.call(arguments)))};return e}),s.flexbox=function(){return J("flexWrap")},s.canvas=function(){var a=b.createElement("canvas");return!!a.getContext&&!!a.getContext("2d")},s.canvastext=function(){return!!e.canvas&&!!F(b.createElement("canvas").getContext("2d").fillText,"function")},s.webgl=function(){return!!a.WebGLRenderingContext},s.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:y(["@media (",n.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},s.geolocation=function(){return"geolocation"in navigator},s.postmessage=function(){return!!a.postMessage},s.websqldatabase=function(){return!!a.openDatabase},s.indexedDB=function(){return!!J("indexedDB",a)},s.hashchange=function(){return A("hashchange",a)&&(b.documentMode===c||b.documentMode>7)},s.history=function(){return!!a.history&&!!history.pushState},s.draganddrop=function(){var a=b.createElement("div");return"draggable"in a||"ondragstart"in a&&"ondrop"in a},s.websockets=function(){return"WebSocket"in a||"MozWebSocket"in a},s.rgba=function(){return D("background-color:rgba(150,255,150,.5)"),G(j.backgroundColor,"rgba")},s.hsla=function(){return D("background-color:hsla(120,40%,100%,.5)"),G(j.backgroundColor,"rgba")||G(j.backgroundColor,"hsla")},s.multiplebgs=function(){return D("background:url(https://),url(https://),red url(https://)"),/(url\s*\(.*?){3}/.test(j.background)},s.backgroundsize=function(){return J("backgroundSize")},s.borderimage=function(){return J("borderImage")},s.borderradius=function(){return J("borderRadius")},s.boxshadow=function(){return J("boxShadow")},s.textshadow=function(){return b.createElement("div").style.textShadow===""},s.opacity=function(){return E("opacity:.55"),/^0.55$/.test(j.opacity)},s.cssanimations=function(){return J("animationName")},s.csscolumns=function(){return J("columnCount")},s.cssgradients=function(){var a="background-image:",b="gradient(linear,left top,right bottom,from(#9f9),to(white));",c="linear-gradient(left top,#9f9, white);";return D((a+"-webkit- ".split(" ").join(b+a)+n.join(c+a)).slice(0,-a.length)),G(j.backgroundImage,"gradient")},s.cssreflections=function(){return J("boxReflect")},s.csstransforms=function(){return!!J("transform")},s.csstransforms3d=function(){var a=!!J("perspective");return a&&"webkitPerspective"in g.style&&y("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},s.csstransitions=function(){return J("transition")},s.fontface=function(){var a;return y('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a},s.generatedcontent=function(){var a;return y(['#modernizr:after{content:"',l,'";visibility:hidden}'].join(""),function(b){a=b.offsetHeight>=1}),a},s.video=function(){var a=b.createElement("video"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),c.h264=a.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),c.webm=a.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,"")}catch(d){}return c},s.audio=function(){var a=b.createElement("audio"),c=!1;try{if(c=!!a.canPlayType)c=new Boolean(c),c.ogg=a.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),c.mp3=a.canPlayType("audio/mpeg;").replace(/^no$/,""),c.wav=a.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),c.m4a=(a.canPlayType("audio/x-m4a;")||a.canPlayType("audio/aac;")).replace(/^no$/,"")}catch(d){}return c},s.localstorage=function(){try{return localStorage.setItem(h,h),localStorage.removeItem(h),!0}catch(a){return!1}},s.sessionstorage=function(){try{return sessionStorage.setItem(h,h),sessionStorage.removeItem(h),!0}catch(a){return!1}},s.webworkers=function(){return!!a.Worker},s.applicationcache=function(){return!!a.applicationCache},s.svg=function(){return!!b.createElementNS&&!!b.createElementNS(r.svg,"svg").createSVGRect},s.inlinesvg=function(){var a=b.createElement("div");return a.innerHTML="<svg/>",(a.firstChild&&a.firstChild.namespaceURI)==r.svg},s.smil=function(){return!!b.createElementNS&&/SVGAnimate/.test(m.call(b.createElementNS(r.svg,"animate")))},s.svgclippaths=function(){return!!b.createElementNS&&/SVGClipPath/.test(m.call(b.createElementNS(r.svg,"clipPath")))};for(var L in s)C(s,L)&&(x=L.toLowerCase(),e[x]=s[L](),v.push((e[x]?"":"no-")+x));return e.input||K(),e.addTest=function(a,b){if(typeof a=="object")for(var d in a)C(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},D(""),i=k=null,function(a,b){function k(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function l(){var a=r.elements;return typeof a=="string"?a.split(" "):a}function m(a){var b=i[a[g]];return b||(b={},h++,a[g]=h,i[h]=b),b}function n(a,c,f){c||(c=b);if(j)return c.createElement(a);f||(f=m(c));var g;return f.cache[a]?g=f.cache[a].cloneNode():e.test(a)?g=(f.cache[a]=f.createElem(a)).cloneNode():g=f.createElem(a),g.canHaveChildren&&!d.test(a)?f.frag.appendChild(g):g}function o(a,c){a||(a=b);if(j)return a.createDocumentFragment();c=c||m(a);var d=c.frag.cloneNode(),e=0,f=l(),g=f.length;for(;e<g;e++)d.createElement(f[e]);return d}function p(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return r.shivMethods?n(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+l().join().replace(/\w+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(r,b.frag)}function q(a){a||(a=b);var c=m(a);return r.shivCSS&&!f&&!c.hasCSS&&(c.hasCSS=!!k(a,"article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")),j||p(a,c),a}var c=a.html5||{},d=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,e=/^<|^(?:a|b|button|code|div|fieldset|form|h1|h2|h3|h4|h5|h6|i|iframe|img|input|label|li|link|ol|option|p|param|q|script|select|span|strong|style|table|tbody|td|textarea|tfoot|th|thead|tr|ul)$/i,f,g="_html5shiv",h=0,i={},j;(function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",f="hidden"in a,j=a.childNodes.length==1||function(){b.createElement("a");var a=b.createDocumentFragment();return typeof a.cloneNode=="undefined"||typeof a.createDocumentFragment=="undefined"||typeof a.createElement=="undefined"}()}catch(c){f=!0,j=!0}})();var r={elements:c.elements||"abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",shivCSS:c.shivCSS!==!1,supportsUnknownElements:j,shivMethods:c.shivMethods!==!1,type:"default",shivDocument:q,createElement:n,createDocumentFragment:o};a.html5=r,q(b)}(this,b),e._version=d,e._prefixes=n,e._domPrefixes=q,e._cssomPrefixes=p,e.mq=z,e.hasEvent=A,e.testProp=function(a){return H([a])},e.testAllProps=J,e.testStyles=y,e.prefixed=function(a,b,c){return b?J(a,b,c):J(a,"pfx")},g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+v.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return o.call(a)=="[object Function]"}function e(a){return typeof a=="string"}function f(){}function g(a){return!a||a=="loaded"||a=="complete"||a=="uninitialized"}function h(){var a=p.shift();q=1,a?a.t?m(function(){(a.t=="c"?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){a!="img"&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l={},o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};y[c]===1&&(r=1,y[c]=[],l=b.createElement(a)),a=="object"?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),a!="img"&&(r||y[c]===2?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i(b=="c"?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),p.length==1&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&o.call(a.opera)=="[object Opera]",l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return o.call(a)=="[object Array]"},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,i){var j=b(a),l=j.autoCallback;j.url.split(".").pop().split("?").shift(),j.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]||h),j.instead?j.instead(a,e,f,g,i):(y[j.url]?j.noexec=!0:y[j.url]=1,f.load(j.url,j.forceCSS||!j.forceJS&&"css"==j.url.split(".").pop().split("?").shift()?"c":c,j.noexec,j.attrs,j.timeout),(d(e)||d(l))&&f.load(function(){k(),e&&e(j.origUrl,i,g),l&&l(j.origUrl,i,g),y[j.url]=2})))}function i(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var j,l,m=this.yepnope.loader;if(e(a))g(a,0,m,0);else if(w(a))for(j=0;j<a.length;j++)l=a[j],e(l)?g(l,0,m,0):w(l)?B(l):Object(l)===l&&i(l,m);else Object(a)===a&&i(a,m)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,b.readyState==null&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright Ã‚Â© 2001 Robert Penner
 * All rights reserved.
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright Ã‚Â© 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/
jQuery.easing.jswing=jQuery.easing.swing;jQuery.extend(jQuery.easing,{def:"easeOutQuad",swing:function(e,f,a,h,g){return jQuery.easing[jQuery.easing.def](e,f,a,h,g)},easeInQuad:function(e,f,a,h,g){return h*(f/=g)*f+a},easeOutQuad:function(e,f,a,h,g){return -h*(f/=g)*(f-2)+a},easeInOutQuad:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f+a}return -h/2*((--f)*(f-2)-1)+a},easeInCubic:function(e,f,a,h,g){return h*(f/=g)*f*f+a},easeOutCubic:function(e,f,a,h,g){return h*((f=f/g-1)*f*f+1)+a},easeInOutCubic:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f+a}return h/2*((f-=2)*f*f+2)+a},easeInQuart:function(e,f,a,h,g){return h*(f/=g)*f*f*f+a},easeOutQuart:function(e,f,a,h,g){return -h*((f=f/g-1)*f*f*f-1)+a},easeInOutQuart:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f+a}return -h/2*((f-=2)*f*f*f-2)+a},easeInQuint:function(e,f,a,h,g){return h*(f/=g)*f*f*f*f+a},easeOutQuint:function(e,f,a,h,g){return h*((f=f/g-1)*f*f*f*f+1)+a},easeInOutQuint:function(e,f,a,h,g){if((f/=g/2)<1){return h/2*f*f*f*f*f+a}return h/2*((f-=2)*f*f*f*f+2)+a},easeInSine:function(e,f,a,h,g){return -h*Math.cos(f/g*(Math.PI/2))+h+a},easeOutSine:function(e,f,a,h,g){return h*Math.sin(f/g*(Math.PI/2))+a},easeInOutSine:function(e,f,a,h,g){return -h/2*(Math.cos(Math.PI*f/g)-1)+a},easeInExpo:function(e,f,a,h,g){return(f==0)?a:h*Math.pow(2,10*(f/g-1))+a},easeOutExpo:function(e,f,a,h,g){return(f==g)?a+h:h*(-Math.pow(2,-10*f/g)+1)+a},easeInOutExpo:function(e,f,a,h,g){if(f==0){return a}if(f==g){return a+h}if((f/=g/2)<1){return h/2*Math.pow(2,10*(f-1))+a}return h/2*(-Math.pow(2,-10*--f)+2)+a},easeInCirc:function(e,f,a,h,g){return -h*(Math.sqrt(1-(f/=g)*f)-1)+a},easeOutCirc:function(e,f,a,h,g){return h*Math.sqrt(1-(f=f/g-1)*f)+a},easeInOutCirc:function(e,f,a,h,g){if((f/=g/2)<1){return -h/2*(Math.sqrt(1-f*f)-1)+a}return h/2*(Math.sqrt(1-(f-=2)*f)+1)+a},easeInElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return -(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e},easeOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k)==1){return e+l}if(!j){j=k*0.3}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}return g*Math.pow(2,-10*h)*Math.sin((h*k-i)*(2*Math.PI)/j)+l+e},easeInOutElastic:function(f,h,e,l,k){var i=1.70158;var j=0;var g=l;if(h==0){return e}if((h/=k/2)==2){return e+l}if(!j){j=k*(0.3*1.5)}if(g<Math.abs(l)){g=l;var i=j/4}else{var i=j/(2*Math.PI)*Math.asin(l/g)}if(h<1){return -0.5*(g*Math.pow(2,10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j))+e}return g*Math.pow(2,-10*(h-=1))*Math.sin((h*k-i)*(2*Math.PI)/j)*0.5+l+e},easeInBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*(f/=h)*f*((g+1)*f-g)+a},easeOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}return i*((f=f/h-1)*f*((g+1)*f+g)+1)+a},easeInOutBack:function(e,f,a,i,h,g){if(g==undefined){g=1.70158}if((f/=h/2)<1){return i/2*(f*f*(((g*=(1.525))+1)*f-g))+a}return i/2*((f-=2)*f*(((g*=(1.525))+1)*f+g)+2)+a},easeInBounce:function(e,f,a,h,g){return h-jQuery.easing.easeOutBounce(e,g-f,0,h,g)+a},easeOutBounce:function(e,f,a,h,g){if((f/=g)<(1/2.75)){return h*(7.5625*f*f)+a}else{if(f<(2/2.75)){return h*(7.5625*(f-=(1.5/2.75))*f+0.75)+a}else{if(f<(2.5/2.75)){return h*(7.5625*(f-=(2.25/2.75))*f+0.9375)+a}else{return h*(7.5625*(f-=(2.625/2.75))*f+0.984375)+a}}}},easeInOutBounce:function(e,f,a,h,g){if(f<g/2){return jQuery.easing.easeInBounce(e,f*2,0,h,g)*0.5+a}return jQuery.easing.easeOutBounce(e,f*2-g,0,h,g)*0.5+h*0.5+a}});

/**
 * Copyright (c) 2007-2014 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 1.4.14
 */
;(function(k){'use strict';k(['jquery'],function($){var j=$.scrollTo=function(a,b,c){return $(window).scrollTo(a,b,c)};j.defaults={axis:'xy',duration:0,limit:!0};j.window=function(a){return $(window)._scrollable()};$.fn._scrollable=function(){return this.map(function(){var a=this,isWin=!a.nodeName||$.inArray(a.nodeName.toLowerCase(),['iframe','#document','html','body'])!=-1;if(!isWin)return a;var b=(a.contentWindow||a).document||a.ownerDocument||a;return/webkit/i.test(navigator.userAgent)||b.compatMode=='BackCompat'?b.body:b.documentElement})};$.fn.scrollTo=function(f,g,h){if(typeof g=='object'){h=g;g=0}if(typeof h=='function')h={onAfter:h};if(f=='max')f=9e9;h=$.extend({},j.defaults,h);g=g||h.duration;h.queue=h.queue&&h.axis.length>1;if(h.queue)g/=2;h.offset=both(h.offset);h.over=both(h.over);return this._scrollable().each(function(){if(f==null)return;var d=this,$elem=$(d),targ=f,toff,attr={},win=$elem.is('html,body');switch(typeof targ){case'number':case'string':if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)){targ=both(targ);break}targ=win?$(targ):$(targ,this);if(!targ.length)return;case'object':if(targ.is||targ.style)toff=(targ=$(targ)).offset()}var e=$.isFunction(h.offset)&&h.offset(d,targ)||h.offset;$.each(h.axis.split(''),function(i,a){var b=a=='x'?'Left':'Top',pos=b.toLowerCase(),key='scroll'+b,old=d[key],max=j.max(d,a);if(toff){attr[key]=toff[pos]+(win?0:old-$elem.offset()[pos]);if(h.margin){attr[key]-=parseInt(targ.css('margin'+b))||0;attr[key]-=parseInt(targ.css('border'+b+'Width'))||0}attr[key]+=e[pos]||0;if(h.over[pos])attr[key]+=targ[a=='x'?'width':'height']()*h.over[pos]}else{var c=targ[pos];attr[key]=c.slice&&c.slice(-1)=='%'?parseFloat(c)/100*max:c}if(h.limit&&/^\d+$/.test(attr[key]))attr[key]=attr[key]<=0?0:Math.min(attr[key],max);if(!i&&h.queue){if(old!=attr[key])animate(h.onAfterFirst);delete attr[key]}});animate(h.onAfter);function animate(a){$elem.animate(attr,g,h.easing,a&&function(){a.call(this,targ,h)})}}).end()};j.max=function(a,b){var c=b=='x'?'Width':'Height',scroll='scroll'+c;if(!$(a).is('html,body'))return a[scroll]-$(a)[c.toLowerCase()]();var d='client'+c,html=a.ownerDocument.documentElement,body=a.ownerDocument.body;return Math.max(html[scroll],body[scroll])-Math.min(html[d],body[d])};function both(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}return j})}(typeof define==='function'&&define.amd?define:function(a,b){if(typeof module!=='undefined'&&module.exports){module.exports=b(require('jquery'))}else{b(jQuery)}}));

// $.fn.imagesLoaded(), see https://github.com/desandro/imagesloaded
;(function(c,n){var l="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";c.fn.imagesLoaded=function(f){function m(){var b=c(i),a=c(h);d&&(h.length?d.reject(e,b,a):d.resolve(e));c.isFunction(f)&&f.call(g,e,b,a)}function j(b,a){b.src===l||-1!==c.inArray(b,k)||(k.push(b),a?h.push(b):i.push(b),c.data(b,"imagesLoaded",{isBroken:a,src:b.src}),o&&d.notifyWith(c(b),[a,e,c(i),c(h)]),e.length===k.length&&(setTimeout(m),e.unbind(".imagesLoaded")))}var g=this,d=c.isFunction(c.Deferred)?c.Deferred():
0,o=c.isFunction(d.notify),e=g.find("img").add(g.filter("img")),k=[],i=[],h=[];c.isPlainObject(f)&&c.each(f,function(b,a){if("callback"===b)f=a;else if(d)d[b](a)});e.length?e.bind("load.imagesLoaded error.imagesLoaded",function(b){j(b.target,"error"===b.type)}).each(function(b,a){var d=a.src,e=c.data(a,"imagesLoaded");if(e&&e.src===d)j(a,e.isBroken);else if(a.complete&&a.naturalWidth!==n)j(a,0===a.naturalWidth||0===a.naturalHeight);else if(a.readyState||a.complete)a.src=l,a.src=d}):m();return d?d.promise(g):
g}})(jQuery);

// placeholders
testPlaceholders = document.createElement('input');
if ('placeholder' in testPlaceholders) {
    document.documentElement.className = document.documentElement.className + " placeholders";
}

// akkordeon
(function ($) {

    $.fn.akkordeon = function() {

        this.each(function(){

            var $this = $(this),
                $details = $this.find(".akkordeon-detail");

            // open first
            $details.not($details[0]).hide();
            $details.first().closest("li").addClass("active");

            $this.find(".akkordeon-link").click(function(e){
                e.preventDefault();

                var $li = $(e.target).closest("li"),
                    $detail = $li.find(".akkordeon-detail");

                // stop ongoing animation
                $details.stop(true, false);

                // slide all other up, exclude current
                $details.not($detail).slideUp(function(){
                    $(this).closest("li").removeClass("active");
                });

                // toggle this one
                $li.find(".akkordeon-detail").slideToggle();

                // toggle class
                $li.toggleClass("active");

            });

        });

        return this;

    }

}(jQuery));

// resize tiles
function initResizeTiles() {

    var resizeTimeout = 0,
        $grid = $(".grid-tiles"),
        $textBoxes = $(".text", $grid),
        $textBox = $textBoxes.first(),
        $elements = $(".text h5", $grid),
        $widestElement,
        cachedWidth = 0,
        dfd = $.Deferred(),
        dfdResolved = false;

    // get widest element
    var w = 0;
    $elements.each(function(i, e){
        var $e = $(e);
        if ($e.width() > w) {
            w = $e.width();
            $widestElement = $e;
        }
    });

    var resize = function() {

        // only on horizontal resize
        if (window.innerWidth == cachedWidth) return;

        // maximum width
        var maxWidth = $textBox.width();

        // hide until resized
        $textBoxes.css("opacity", 0);

        // delay
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){

            if ($grid.find(" > li:visible:not(.grid-full)").length == 0) {
                return;
            }

            // current font-size
            var fontSize = parseInt($widestElement.css("font-size"));

            // larger?
            if ($widestElement.width() > maxWidth) {

                while ($widestElement.width() > maxWidth) {
                    fontSize--;
                    $widestElement.css("font-size", fontSize);
                }

            }
            // smaller?
            else {

                while ($widestElement.width() < maxWidth) {
                    fontSize++;
                    $widestElement.css("font-size", fontSize);
                }

                // one step smaller, we went too far
                fontSize--;

            }

            // apply font-size, show again
            $elements.css("font-size", fontSize);
            $textBoxes.removeAttr("style");

            cachedWidth = window.innerWidth;

            if (!dfdResolved) {
                dfdResolved = true;
                dfd.resolve();
            }

        }, 100);

    }
    $(window).on("resize", resize).trigger("resize");

    return dfd;

}

// beratungsfelder: details
function initBeratungsfelderDetails() {

    function scrollTo($anchor, showAnchor) {

        return $.Deferred(function(dfd){

            if(typeof showAnchor != 'undefined' && showAnchor == true) {
                var topOffset = 0;
            } else {
                var topOffset = $anchor.innerHeight() + 2;
            }

            if (window.innerWidth >= 1060)      topOffset -= 160;
            else if (window.innerWidth >= 700)  topOffset -= 110;

            $.scrollTo($anchor, 750, {
                axis: "y",
    			offset: {
    				top: topOffset
    			},
    			easing: 'easeInOutSine',
                onAfter: function(){
                    dfd.resolve();
                }
    		});

        });

    }

    var $tiles = $("a.tile"), // all tiles
        elementsPerRow = false; // elements per row

    // set elements per row, close open rows on resize
    /* 11/2019 - not needed anymore, functionality seems to have been removed
    $(window).on("resize", function(){

        // get anchor
        if (window.innerWidth >= 600)       var tmpElementsPerRow = 3;
        else if (window.innerWidth >= 500)  var tmpElementsPerRow = 2;
        else                                var tmpElementsPerRow = 1;

        // close all if row-count switched, reopen current
        if (elementsPerRow !== false && tmpElementsPerRow != elementsPerRow) {

            var $previouslyActiveTile = $tiles.filter(".active");

            $.when(closeDetails($previouslyActiveTile)).then(function(){
                if ($previouslyActiveTile.length == 1) {
                    $previouslyActiveTile.removeClass("active").trigger("click");
                }
            });

        }

        // set new
        elementsPerRow = tmpElementsPerRow;

    }).trigger("resize");
    */

    // preset filter of categories
    var mixItUpFilter = "all";
    if(window.location.hash) {
        var hash = window.location.hash.replace("#", "");
        if (hash.indexOf("category") > -1) {
            var $target = $(".grid-tiles li." + hash);
            if ($target.length > 0) {
                mixItUpFilter = "." + hash;
            }
        }
    }
    // filter
    // init after font-sizes have been checked out
    $.when(initResizeTiles()).then(function(){

        var $beratungsfelder = $(".grid-beratungsfelder");

        $beratungsfelder.addClass("sizes-calculated").mixItUp({
    		load: {
    			filter: mixItUpFilter // initial filter
    		},
    		callbacks: {
                // after animation on first load finished
    			onMixLoad: function(){

                    // category chosen? => activate button and scroll to button
                    if (mixItUpFilter != "all") {
                        $("button.selection").removeClass("active");
                        $("button.selection[data-selection='" + mixItUpFilter + "']").addClass("active");
                        window.setTimeout(function(){
                            scrollTo($("button.selection:first"), true);
                        }, 250);
                    }

    		    },
                onMixEnd: function(){
                    $tiles = $("a.tile:visible");

                }
    		}
    	});

        $("button.selection").on('click', function(e){
            e.preventDefault();
            var $this = $(this);
            $("button.selection.active").removeClass("active");
            $this.addClass("active");
            $beratungsfelder.mixItUp('filter', $this.data("selection"));
        });

    });

}

// experten
function initExperten() {

    /*  --------------------------
    helpers
    ------------------------------ */

    // scrolling-helper
    function scrollTo($anchor, showAnchor) {

        return $.Deferred(function(dfd){

            if(typeof showAnchor != 'undefined' && showAnchor == true) {
                var topOffset = 0;
            } else {
                var topOffset = $anchor.innerHeight() + 2;
            }

            if (window.innerWidth >= 1060)      topOffset -= 160;
            else if (window.innerWidth >= 700)  topOffset -= 110;

            $.scrollTo($anchor, 750, {
                axis: "y",
    			offset: {
    				top: topOffset
    			},
    			easing: 'easeInOutSine',
                onAfter: function(){
                    dfd.resolve();
                }
    		});

        });

    }

    // close all open details, remove "active"-class from tiles (optionally exclude current tile)
    function closeDetails(excludeTile) {

        return $.Deferred(function(dfd){

            var $gridFull = $(".grid-full");

            if ($gridFull.length > 0) {

                var $previouslyOpenTile = $("a.tile.active").not(excludeTile);

                $previouslyOpenTile.removeClass("active");

                // modal
                if (elementsPerRow === 999) {

                    // lock height
                    $grid.css("height", $grid.height()).addClass("fixed");

                    // hide cloned details
                    var liCloneFadedOut = $gridFull.fadeIn(function(){
                        $(this).remove();
                    });

                    // fade in tiles
                    $.when(liCloneFadedOut, $grid.find("> li:not(.grid-full)").fadeIn()).then(function(){

                        // tiles faded out & cloned details faded in => unlock height
                        $grid.removeClass("fixed").css("height", "auto");

                        $.when(scrollTo($grid, true)).then(function(){
                            dfd.resolve()
                        });
                    });

                } else {

                    $gridFull.slideUp(function(){
                        var $this = $(this);
                        $this.remove();
                        if (typeof excludeTile == 'undefined') {
                            $.when(scrollTo($previouslyOpenTile, true)).then(function(){
                                dfd.resolve()
                            });
                        } else {
                            dfd.resolve();
                        }
                    });

                }


            } else {
                dfd.resolve();
            }

        });

    }

    // previous expert (overlay only)
	function slidePrevious() {

		// we are animating
		animating = true;

        // get next
        var $allElements = $(".grid-experten > li:not(.grid-full)");
        var $currentElement = $(".tile.active").closest("li");

        var $previous = $currentElement.prevAll(".grid-experten > li:not(.grid-full)").length ? $currentElement.prevAll(".grid-experten > li:not(.grid-full)").first() : $allElements.last();

        // insert previous element
        var $previousDetail = $previous.find(".experten-detail").clone();
        $previousDetail.find("ul.akkordeon").akkordeon();
        $(".container").prepend($previousDetail);

        // offset
        $(".container .experten-detail").css({
            "-webkit-transform": "translateX(-100%)",
                "-ms-transform": "translateX(-100%)",
                    "transform": "translateX(-100%)"
        });

        // activate
        $currentElement.find("a.tile").removeClass("active");
        $previous.find("a.tile").addClass("active");

        // I know.
        window.setTimeout(function(){
            $(".container .experten-detail").addClass("animating").css({
                "-webkit-transform": "translateX(0%)",
                    "-ms-transform": "translateX(0%)",
                        "transform": "translateX(0%)"
            });
        }, 25);

        // I know that too.
        window.setTimeout(function(){
            $(".container .experten-detail").removeClass("animating");
            $(".container .experten-detail").last().remove();
            $(".container .experten-detail").removeAttr("style");
            animating = false;
        }, (runningTimeTransition + 250));

	}

    // next expert (overlay only)
	function slideNext() {

		// we are animating
		animating = true;

        // get next
        var $allElements = $(".grid-experten > li:not(.grid-full)");
        var $currentElement = $(".tile.active").closest("li");

        var $next = $currentElement.nextAll(".grid-experten > li:not(.grid-full)").length ? $currentElement.nextAll(".grid-experten > li:not(.grid-full)").first() : $allElements.first();
        // var $previous = $currentElement.prev("li").length ? $currentElement.prev("li") : $allElements.last();

        // insert next element
        var $nextDetail = $next.find(".experten-detail").clone();
        $nextDetail.find("ul.akkordeon").akkordeon();
        $(".container").append($nextDetail);

        // activate
        $currentElement.find("a.tile").removeClass("active");
        $next.find("a.tile").addClass("active");

        // I know.
        window.setTimeout(function(){
            $(".container .experten-detail").addClass("animating").css({
                "-webkit-transform": "translateX(-100%)",
                    "-ms-transform": "translateX(-100%)",
                        "transform": "translateX(-100%)"
            });
        }, 25);

        // I know that too.
        window.setTimeout(function(){
            $(".container .experten-detail").removeClass("animating");
            $(".container .experten-detail").first().remove();
            $(".container .experten-detail").removeAttr("style");
            animating = false;
        }, (runningTimeTransition + 250));

	}


    /*  --------------------------
    global variables
    ------------------------------ */

    var $tiles = $("a.tile"), // all tiles
        $grid = $(".grid-experten"),
        $arrows = $("<a href='#' class='experten-previous experten-arrow arrow arrow arrow-left'></a><a href='#' class='experten-next experten-arrow arrow'></a>"),
        $li = $("<li class='grid-full' style='display: none'><div class='mask'><div class='container'></div></div></li>"),
        elementsPerRow = 0, // elements per row
        animating = false,
        runningTimeTransition = 250, // magic number from css
        overlayFromWidth = 1020; // magic number

    /*  --------------------------
    bindings
    ------------------------------ */

    // set elements per row, close open rows on resize
    var resizeTimeout = 0;
    var cachedWidth = 0;
    var resize = function() {

        // only on horizontal resize
        if (window.innerWidth == cachedWidth) return;

        // throttle
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){

            // get anchor
            if (window.innerWidth >= overlayFromWidth)  var tmpElementsPerRow = 999;
            else if (window.innerWidth >= 900)          var tmpElementsPerRow = 3;
            else if (window.innerWidth >= 500)          var tmpElementsPerRow = 2;
            else                                        var tmpElementsPerRow = 1;

            // close all if row-count switched, reopen current
            if (elementsPerRow !== false && tmpElementsPerRow != elementsPerRow) {

                var $previouslyActiveTile = $tiles.filter(".active");

                $.when(closeDetails($previouslyActiveTile)).then(function(){
                    if ($previouslyActiveTile.length == 1) {
                        $previouslyActiveTile.removeClass("active").trigger("click");
                    }
                });

            }

            // set new
            elementsPerRow = tmpElementsPerRow;

            cachedWidth = window.innerWidth;

        }, 100);

    }
    $(window).on("resize", resize).trigger("resize");

    // click on tile
    $("a.tile").click(function(e){

        e.preventDefault();

        var $tile = $(e.target).closest(".tile");
            active = $tile.hasClass("active");

        $tile.toggleClass("active");

        $.when(closeDetails($tile)).then(function(){

            if (!active) {

                // current index
                var currentIndex = $tiles.index($tile);
                var anchorIndex = Math.min($tiles.length-1, currentIndex + (elementsPerRow - (currentIndex % elementsPerRow) - 1));
                var $anchor = $tiles.eq(anchorIndex);

                // insert clone
                var $clone = $($tile.attr("href")).clone();
                $clone.find("ul.akkordeon").akkordeon();
                var $liClone = $li.clone();
                $liClone.find(".container").html($clone);

                $liClone.insertAfter($anchor.closest("li"));

                // as overlay
                if (elementsPerRow == 999) {

                    // lock height
                    $grid.css("height", $grid.height()).addClass("fixed");

                    // show cloned details
                    var liCloneFadedIn = $liClone.fadeIn();

                    // fade out tiles
                    $.when(liCloneFadedIn, $grid.find("> li:not(.grid-full)").fadeOut()).then(function(){

                        // tiles faded out & cloned details faded in => unlock height
                        $grid.removeClass("fixed").css("height", "auto");

                        // add arrows (they need relative li)
                        $arrows.clone().appendTo($liClone);

                        scrollTo($grid, true);

                    });

                }
                // inline
                else {

                    $liClone.slideDown(function(){
                        scrollTo($tile, true);
                    });

                }

            }

        });

    });

    // close
    $(".grid-experten").on("click", ".close", function(e){
        e.preventDefault();
        closeDetails();
    });

    // previous / next
    $(".grid-experten").on("click", ".experten-arrow", function(e){
        e.preventDefault();
        // only if not already animating
        if (animating)      return;

        if ($(e.target).hasClass("experten-previous"))      slidePrevious();
        else                                                slideNext();

    });

    // deeplink
    if(window.location.hash) {
        var hash = window.location.hash.replace("#", "");
        var $target = $(".grid-tiles li." + hash);
        if ($target) {
            window.setTimeout(function(){
                $target.find("a.tile").triggerHandler("click");
            }, 250);
        }
    }


}


// jQuery Ready-Handler
$(function() {

    /* scrolling */
    var $body = $("body");
    var bodyScrolledDetected = false;
    var bodyScrolledAfter = 200;
    $(window).on('scroll', function() {
        scrollPosition = $(this).scrollTop();
        if (scrollPosition >= bodyScrolledAfter && !bodyScrolledDetected) {
            $body.addClass("scrolled");
            bodyScrolledDetected = true;
        } else if (scrollPosition < bodyScrolledAfter && bodyScrolledDetected) {
            $body.removeClass("scrolled");
            bodyScrolledDetected = false;
        }
    }).trigger("scroll");

    /* on-page scrollto */
    $("a.scrollto").click(function(e){

        var $anchor = $($(e.target).attr("href"));
        if (!$anchor)       return;

        e.preventDefault();

        if (window.innerWidth >= 1060)      var topOffset = -160;
        else if (window.innerWidth >= 700)  var topOffset = -110;

        $.scrollTo($anchor, 750, {
            axis: "y",
			offset: {
				top: topOffset
			},
			easing: 'easeInOutSine'
		});

    });

    /* smartphone navigation */
    var $body = $("body");
    var $navMain = $(".nav-main");
    $(".header-burger").click(function(event){
        event.preventDefault();
        $body.toggleClass("nav-out");
    });

    /* lawyers */
    $(".no-touch .lawyers li").bind("mouseenter", function(event) {
        $(this).addClass("active");
    }).bind("mouseleave", function(event) {
        $(this).removeClass("active");
    });
    $(".touch .lawyers li").on("touchstart", function(event) {
        var $this = $(this);
        // give touchmove some time
        var cancel = window.setTimeout(function(){
            $this.toggleClass("active");
        }, 200);
        // cancel touch-event
        $this.one("touchmove", function(event){
            window.clearTimeout(cancel);
        });
    });

    /* slider masthead*/
    if ($('.masthead-slider').length > 0) {
        $('.masthead-slider').slick();
    }

    /* start: standorte */
    (function(){

        if ($(".block-standorte").length > 0) {

            var $window = $(window);

            // Resize wegen Responsive
            $window.on("resize", function(){

                var $items = $(".block-standorte .one-third");

                // immer zuerst alle Element auf ihre natürliche Höhe bringen
                $items.css("height", "auto");

                if (window.innerWidth >= 700) {

                    var maxHeight = 0;

                    // jetzt durchläuft man diese Reihe und setzt den maxHeight-Wert
                    $items.each(function(){
                        var itemHeight = parseInt( $( this ).outerHeight() );
                        if ( itemHeight > maxHeight ) maxHeight = itemHeight;
                    });
                    $items.css( 'height', maxHeight );

                }

            }).trigger("resize");

        }

        $(".google-map__trigger-item").click(function(e){
            e.preventDefault();
            var scrollTop = $("#map-canvas").offset().top;
            if ($(".site-header").css("position") == "fixed") {
                scrollTop-= $(".site-header").outerHeight() - 1;
            }
            $("html, body").animate({scrollTop:scrollTop}, 500, 'swing');
        });

    })();

});
